import { FormsModule } from '@angular/forms';
import { CustomAlertComponent } from './custom-alert/custom-alert.component';
import { MeditabsComponent } from './meditabs/meditabs.component';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FlashcardComponent } from './flashcard/flashcard.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FilesComponent } from './files/files.component';

@NgModule({
  declarations: [
    FlashcardComponent,
    MeditabsComponent,
    CustomAlertComponent,
    HeaderComponent,
    FilesComponent
  ],
  exports: [
    FlashcardComponent,
    MeditabsComponent,
    CustomAlertComponent,
    FilesComponent,
    HeaderComponent
  ],
  entryComponents: [CustomAlertComponent],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    IonicModule,
  ]
})
export class ComponentsModule { }
